import { requestFromServer } from "./api-client";

const CargillBranchClient = {
  getAll: async () => {
    return requestFromServer("v1/Cargill_Branches/getAll");
  },
  getAvailableByProductId: async (productId, loadTypeId) => {
    return requestFromServer(
      `v1/Cargill_Branches/getAvailableByProductId/${productId}/${loadTypeId}`
    );
  },
  getAvailableByPlantId: async (plantId, loadTypeId) => {
    return requestFromServer(
      `v1/Cargill_Branches/getAvailableByPlantId/${plantId}/${loadTypeId}`
    );
  },
};

export default CargillBranchClient;
